import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { Badge } from 'primereact/badge';
import { ProgressSpinner } from 'primereact/progressspinner';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import formattedDate from '../../../formatDate';
const apiUrl = process.env.REACT_APP_API_URL;

const DriverProfile = ({ driverId }) => {
    const [stats, setStats] = useState([]);
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        const fetchDashboard = async () => {
            try {
             
                const resStats = await fetch(`${apiUrl}IHM/api/get_driver_stats.php?id=${driverId}`);
                const dataStats = await resStats.json();
           
                const resOrders = await fetch(`${apiUrl}IHM/api/get-courses.php?id=${driverId}&effectue=1`);
                const dataOrders = await resOrders.json();

                setStats(dataStats.stats);
                setOrders(dataOrders.slice(0, 2)); 
                setLoading(false);
            } catch (error) {
                console.error("Erreur de chargement", error);
                setLoading(false);
            }
        };

        fetchDashboard();
    }, [driverId]);

    if (loading)
      return (
        <div className="min-h-screen bg-gray-50 flex align-items-center justify-content-center">
          <div className="text-center">
            <ProgressSpinner style={{ width: "50px", height: "50px" }} />
            <p className="text-600 ">Chargement des informations du profil...</p>
          </div>
        </div>
      );

    return (
        <div className="surface-ground font-sans" style={{ maxWidth: '450px', margin: '0 auto' }}>
            <div className="p-3 grid grid-nogutter">
                {stats.map((stat, index) => (
                    <div key={index} className="col-6 p-1">
                        <div style={{backgroundColor: `${stat.bg}`}} className={`text-white p-3 border-round shadow-1 relative`} >
                            <div className="text-lg font-bold mb-1">{stat.value}</div>
                            <div className="text-xs font-semibold uppercase opacity-70" style={{ lineHeight: '1.2' }}>
                                {stat.label}
                            </div>
                            {stat.icon && (
                                <i className={`${stat.icon} absolute`} style={{ right: '12px', bottom: '12px', fontSize: '1.4rem', opacity: 0.5 }}></i>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            <div className="px-3 mt-2">
                <h3 className="text-900 mb-3 px-1">Dernières courses</h3>
                {orders.map((order, index) => (
                    <Card key={index} className="mb-3 shadow-1 border-none border-left-1 ">
                        <div className="flex justify-content-between align-items-center mb-2">
                            <span className="font-bold text-lg text-800">#{order.id}</span>
                            <span className="text-500 text-xs">{formattedDate(order.date_depart)}</span>
                        </div>

                        <div className="flex align-items-start gap-2 text-600 mb-2">
                            <i className="pi pi-map-marker mt-1 text-orange-500"></i>
                            <span className="text-xs font-medium">{order.destination}</span>
                        </div>

                        <div className="flex align-items-center gap-2 text-500 text-xs italic">
                            <i className="pi pi-user text-xs"></i>
                            <span>{order.client} • {order.nb_passagers} pers.</span>
                        </div>
                    </Card>
                ))}
            </div>



        </div>
    );
};

export default DriverProfile;